// Translation helper utilities
// Ensures buttons always show proper text, not translation keys

const isArabicDocumentLang = (): boolean =>
  typeof document !== 'undefined' && document.documentElement.getAttribute('lang') === 'ar';

/**
 * Get translation with fallback.
 * When the document language is Arabic, never use the English `fallback` string — use a neutral Arabic line instead.
 */
export const getTranslation = (
  t_nested: (path: string) => string,
  key: string,
  fallback: string
): string => {
  const translated = t_nested(key);
  const missing =
    translated === key || translated.startsWith(`${key.split('.')[0]}.`);
  if (!missing) return translated;
  if (isArabicDocumentLang()) {
    const soft = t_nested('loading.general');
    return soft !== 'loading.general' ? soft : '…';
  }
  return fallback;
};

/** Replace dashes with spaces for display (e.g. right-of-way → right of way) */
export const formatTestNameForDisplay = (name: string): string => name.replace(/-/g, ' ');































